import type { IconDefinition } from '@vrplatform/icons';
import type { Account } from './useAccountsQuery';

export type BankAccountCategory = NonNullable<
  NonNullable<Account['banking']>['category']
>;

type BankAccountCategoryDetails = {
  icon: IconDefinition;
  label: 'Trust' | 'Operating' | 'External';
};

export const getBankAccountCategoryDetails = (
  category?: BankAccountCategory | null
): BankAccountCategoryDetails | null => {
  switch (category) {
    case 'trust':
      return {
        icon: 'BookOpenIcon',
        label: 'Trust',
      };
    case 'operating':
      return {
        icon: 'BriefcaseIcon',
        label: 'Operating',
      };
    case 'external':
      return {
        icon: 'CreditCardOutcomeIcon',
        label: 'External',
      };
    default:
      return null;
  }
};
